import {
  BusinessEntitlementConfig,
  EntitlementName,
} from "@shared/types/localTypes/entitlements.ts";
import { entitlementsService } from "@shared/services/entitlements.ts";
import { requestCurationTrial } from "@shared/utils/curationTrialRequestUtil.ts";

const entitlement: BusinessEntitlementConfig = {
  entitlementName: EntitlementName.BUSINESS_SECURITY_CURATION_USERS,
  displayName: "Curation",
  isCustomerFacing: true,
  displayOrder: 6,
  cardConfig: {
    isTrial: (subscription) =>
      !!subscription.meta.hasCurationTrial && !subscription.meta?.isTrial,
    expirationDate: (subscription) =>
      entitlementsService.getEntitlement(
        subscription,
        EntitlementName.BUSINESS_SECURITY_CURATION_USERS,
      )?.endDate,
    icon: "curation",
    title: "Curation",
    displayEmptyState: true,
    valueTransformer: (value, hasCurationTrial) => {
      const userQty = hasCurationTrial
        ? "Unlimited"
        : Number(value).toLocaleString("en-US");
      return `${userQty} Users`;
    },
    valueTransformerSH: (value) => {
      return {
        display: value !== "N/A",
        value: Number(value).toLocaleString("en-US"),
        units: "Users",
      };
    },
    setMeUp: async (requestTrialParams) => {
      await requestCurationTrial(requestTrialParams);
    },
  },
};

export default entitlement;
